// @flow

import * as React from "react";

import PubSub from "../modules/util/pubsub";

const { useState, useEffect } = React;

const useDatePickerState = (
    initialState: any = {}
): {
    datePickersState: any,
    setDateFieldValue: (datePickerId: string, value: string) => void,
    setDatePickersState: (value: any) => void,
} => {
    const [datePickersState, setDatePickersState] = useState(initialState);

    const setDateFieldValue = (datepickerId: string, value: string) => {
        setDatePickersState((oldState: any): any => {
            return {
                ...oldState,
                [datepickerId]: value,
            };
        });
    };

    useEffect((): any => {
        const subscription = PubSub.subscribe(
            "datepicker",
            (event: { id: string, type: string, date: string }) => {
                if (event.type === "dateSelection") {
                    setDateFieldValue(event.id, event.date);
                }
            }
        );
        return () => {
            subscription.remove();
        };
    }, []);

    return {
        datePickersState,
        setDateFieldValue,
        setDatePickersState,
    };
};

export default useDatePickerState;
